/**
 * The Overview page header (BON-534).
 *
 * The shared `DashboardPageHeader`, wired to Overview: a FIXED title with the
 * current scope beside it as an eyebrow, and the region's trail beneath. The
 * shell passes the constant "Overview" at every scope, so someone landing deep
 * in the hierarchy is still told which page they are on; the region name sits
 * next to it, and clicking it opens the scope picker.
 *
 * The trail goes BELOW the title, as the design has it — it explains where the
 * named scope sits, so it reads after the name rather than before.
 */
import { DashboardPageHeader } from '../../primitives/DashboardPageHeader';

import type { OverviewRegionAncestor, OverviewRegionRow } from './overview-types';
import { useOverviewViewport } from './overview-viewport';
import { OverviewScopePicker } from './OverviewScopePicker';
import { RegionBreadcrumb } from './RegionBreadcrumb';

export interface OverviewHeaderProps {
  /** Absent at all-regions scope. */
  region?: OverviewRegionRow;
  ancestors?: OverviewRegionAncestor[];
}

export function OverviewHeader({ region, ancestors = [] }: OverviewHeaderProps) {
  const { isPhone } = useOverviewViewport();

  return (
    <DashboardPageHeader
      title="Overview"
      isPhone={isPhone}
      scope={
        <OverviewScopePicker
          label={region ? region.name : 'All regions'}
          currentRegionId={region?.id ?? null}
        />
      }
      below={region ? <RegionBreadcrumb region={region} ancestors={ancestors} /> : undefined}
    />
  );
}
